import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Edit, FileText, List, Calendar } from "lucide-react";
import type { EvaluationFormWithItems } from "@/types/evaluation-form";

interface FormularioCardProps {
  formulario: EvaluationFormWithItems;
  onEdit?: () => void;
}

export function FormularioCard({ formulario, onEdit }: FormularioCardProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">{formulario.name}</CardTitle>
          </div>
          <Badge variant={formulario.is_active ? "default" : "secondary"}>
            {formulario.is_active ? "Ativo" : "Inativo"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {formulario.description && (
          <p className="text-sm text-muted-foreground line-clamp-2">
            {formulario.description}
          </p>
        )}

        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <List className="h-4 w-4" />
            <span>{formulario.items?.length || 0} itens</span>
          </div>
          <div className="flex items-center gap-1">
            <Calendar className="h-4 w-4" />
            <span>{formatDate(formulario.created_at)}</span>
          </div>
        </div>

        {formulario.items && formulario.items.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {formulario.items.slice(0, 4).map((item) => (
              <Badge key={item.id} variant="outline" className="text-xs">
                {item.label}
              </Badge>
            ))}
            {formulario.items.length > 4 && (
              <Badge variant="outline" className="text-xs">
                +{formulario.items.length - 4}
              </Badge>
            )}
          </div>
        )}

        {onEdit && (
          <div className="pt-2 border-t">
            <Button variant="outline" size="sm" onClick={onEdit} className="w-full">
              <Edit className="mr-2 h-4 w-4" />
              Editar Formulário
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

